import React from 'react';
import styled, { useTheme } from 'styled-components';
import ModalComponent from '../../../components/Modal';
import { ParagraphLargeText, TitleMedium } from '../../../components/Texts';
import Button from '../../../components/Button';
import { useDispatch } from 'react-redux';
import { closeModal } from '../../../redux/slices/modals';
import { toast } from 'react-toastify';

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-items: center;
  padding: 20px;
  width: 100%;
`;

const CodeContainer = styled.div`
  background-color: ${({ theme }) => theme.background.secondary || theme.background.light};
  border-radius: 12px;
  padding: 20px;
  width: 100%;
  text-align: center;
  border: 2px dashed ${({ theme }) => theme.border.primary};
`;

const CodeText = styled(TitleMedium)`
  font-family: monospace;
  font-size: 24px;
  letter-spacing: 2px;
  color: ${({ theme }) => theme.text.title};
  margin: 0;
  word-break: break-all;
`;

const MessageText = styled(ParagraphLargeText)`
  text-align: center;
  color: ${({ theme }) => theme.text.regular};
  margin: 0;
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
`;

const DiscountCodeCreated = ({ code, onClose }) => {
  const theme = useTheme();
  const dispatch = useDispatch();

  const handleClose = () => {
    if (onClose) {
      onClose();
    } else {
      dispatch(closeModal());
    }
  };

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(code);
      toast('Discount code copied to clipboard!', {
        type: 'success',
      });
    } catch (err) {
      console.error('Failed to copy code:', err);
      toast('Failed to copy code', {
        type: 'error',
      });
    }
  };

  return (
    <ModalComponent onClose={handleClose}>
      <ContentContainer>
        <MessageText>Discount code created successfully!</MessageText>
        <CodeContainer>
          <CodeText>{code}</CodeText>
        </CodeContainer>
        <ButtonContainer>
          <Button onClick={handleCopy} variant="secondary" fullWidth>
            Copy Code
          </Button>
          <Button onClick={handleClose} fullWidth>
            Close
          </Button>
        </ButtonContainer>
      </ContentContainer>
    </ModalComponent>
  );
};

export default DiscountCodeCreated;
